import { Badge } from '@chakra-ui/react';
import React from 'react';
import RegistrationState from '../../utils/RegistrationStates';
import {RegistrationStateText} from "../../model/census";

interface RegistrationStateBadgeProps {
    registrationState: string;
    marginTop?: number
}

const RegistrationStateBadge: React.FC<RegistrationStateBadgeProps> = (props) => {

    let badgeColorScheme : string = 'grey';

    console.log("State is: " + props.registrationState)
    switch (props.registrationState)
    {
        case RegistrationState.registered:
            badgeColorScheme = 'green';
            break;

        case RegistrationState.inProcess:
            badgeColorScheme = 'yellow';
            break;

        case RegistrationState.rejected:
            badgeColorScheme = 'red';
            break;

        case RegistrationState.accepted:
            badgeColorScheme = 'blue';
            break;
            
        case RegistrationState.suspended:
            badgeColorScheme = 'orange';
            break;
            
        default:
            break;
    }
    console.log("badgeColorScheme: " + badgeColorScheme)

    return (
        <Badge marginTop={props.marginTop} colorScheme={badgeColorScheme}>{props.registrationState}</Badge>
    );
};

export default RegistrationStateBadge;